'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive('guSectionTitle', function () {
  return {
    restrict: 'E',
    replace: true,
    scope: {},
    transclude: true,
    template: "\n            <div class=\"gu-section-title\">\n                <div class=\"line-around line-before\"></div>\n                <div class=\"content\">\n                    <h3 ng-transclude></h3>\n                </div>\n                <div class=\"line-around line-after\"></div>\n            </div>\n        "
  };
});
ngModule.directive('guSection', function () {
  return {
    restrict: 'E',
    replace: true,
    scope: {},
    transclude: true,
    template: "<div class=\"gu-section\" ng-transclude></div>"
  };
});
ngModule.directive('guSectionContent', function () {
  return {
    restrict: 'E',
    replace: true,
    scope: {},
    transclude: true,
    template: "<div class=\"gu-section-content\" ng-transclude></div>"
  };
});
ngModule.directive('guImageBox', function () {
  return {
    restrict: 'E',
    replace: true,
    scope: {},
    transclude: true,
    template: "<div class=\"gu-image-box\" ng-transclude></div>"
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/guide-utilisateur/gu-section-title.js
// module id = 2955
// module chunks = 13